<div class="event-card-container">
  <div class="img-card">
    <img [src]="event.imageUrl" [alt]="event.title" loading="lazy" />
    <span class="date-badge">{{ formattedDate }}</span>
  </div>
  <div class="card-info">
    <div class="card-info-top">
      <div class="card-info-text">
        <h1>{{ event.title }}</h1>
        @if (event.subTitle) {
        <p class="subtitle">{{ event.subTitle }}</p>
        }
        <p class="details">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          {{ formattedTime }}
          <span class="separator">·</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          {{ event.saloonName }}
        </p>
      </div>
      <button
        type="button"
        class="interest-btn"
        [class.interested]="event.isInterested"
        (click)="onToggleInterest($event)"
        [title]="event.isInterested ? 'Retirer mon intérêt' : 'Je suis intéressé(e)'"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          [attr.fill]="event.isInterested ? 'currentColor' : 'none'"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polygon
            points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
          />
        </svg>
        @if (event.interestedCount) {
        <span class="interest-count">{{ event.interestedCount }}</span>
        }
      </button>
    </div>
  </div>
</div>
